import {
  AloftArea,
  CraftsmanCostProps,
  ORDER_FEATURES,
  getCraftsmanCost,
  isUndefined,
} from '@aloft/toolkit-shared';

import { selectImprovementsEntities } from '../propertyDataSelectors/improvementsSelectors.ts';
import { selectPropertyIdentificationEntities } from '../propertyDataSelectors/propertyIdentificationSelectors.ts';
import { createFeatureCostSelectors } from '../utils/createFeatureCostSelectors.ts';
import { selectCostProps } from './selectCostProps.ts';

const calculateCarportCost = (
  costProps: CraftsmanCostProps,
  improvements: ReturnType<typeof selectImprovementsEntities>,
  propertyIdentification: ReturnType<typeof selectPropertyIdentificationEntities>,
  id: string,
) => {
  const improvementsForTransaction = improvements[id];
  const propertyIdentificationForTransaction = propertyIdentification[id];

  if (!improvementsForTransaction || !propertyIdentificationForTransaction) {
    return undefined;
  }

  const {
    carport,
    craftsmanQuality: dwellingQuality,
    propertyType = 'singleFamilyResidence',
  } = improvementsForTransaction;

  if (!carport || !carport.area || !ORDER_FEATURES.carport.hasFeature(improvementsForTransaction)) {
    return undefined;
  }

  const {
    address: { PostalCode: zipCode },
  } = propertyIdentificationForTransaction;

  if (
    isUndefined(dwellingQuality) ||
    (dwellingQuality * 10) % 1 !== 0 ||
    dwellingQuality < 1 ||
    isUndefined(zipCode)
  ) {
    return undefined;
  }

  const calculator = getCraftsmanCost(costProps);

  return calculator.getCarportCost({
    sqft: AloftArea.schema.parse(carport.area),
    quality: carport.quality ?? dwellingQuality,
    propertyType,
    zipCode,
  });
};

export const {
  selectCarportCost,
  selectZipOnlyCarportCost,
  selectCarportCosts,
  selectCarportCostDisplay,
} = createFeatureCostSelectors({
  calculate: calculateCarportCost,
  inputSelectors: [
    selectCostProps,
    selectImprovementsEntities,
    selectPropertyIdentificationEntities,
  ],
  names: {
    cost: 'selectCarportCost',
    zipOnly: 'selectZipOnlyCarportCost',
    costs: 'selectCarportCosts',
    display: 'selectCarportCostDisplay',
  },
});
